import { InfoIcon, FolderIcon, CodeIcon } from '@wf-sl/common-icons'
import { InfoModule, ApplicationsModule, DeveloperModule, SignUpModule, HomeModule } from './loadable-modules'

/**
 * This application's modules configuration.
 *
 * @type {ModuleConfig}
 *
 * @see {@link https://bitbucket.ttt-sp.com/projects/FRONTEND/repos/ui-shared-libraries/browse/packages/common/base/src/prop-types/module-config-prop-type.js}
 * @see {@link https://bitbucket.ttt-sp.com/projects/FRONTEND/repos/ui-shared-libraries/browse/packages/common/base/src/prop-types/module-config-entry-prop-type.js}
 */
const moduleConfig = [
    {
        component: HomeModule,
        isEntryPoint: true,
        moduleId: 'home',
        path: '/home',
        public: true
    },
    {
        component: InfoModule,
        iconComponent: InfoIcon,
        moduleId: 'info',
        path: '/info',
        public: true
    },
    {
        component: ApplicationsModule,
        iconComponent: FolderIcon,
        moduleId: 'applications',
        path: '/applications',
        title: 'My Integrations'
    },
    {
        component: SignUpModule,
        moduleId: 'sign-up',
        path: '/sign-up',
        public: true,
        title: 'Sign Up'
    },
    {
        component: DeveloperModule,
        iconComponent: CodeIcon,
        moduleId: 'developer',
        path: '/developer',
        public: true,
        title: 'Developer Docs'
    }
]

export { moduleConfig }
